export default function NewArrivals() {
  return (
    <section id="new-arrivals" className="py-16 bg-cream-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-8">
          <h2 className="font-serif text-5xl text-ink-900">
            Neu eingetroffen
          </h2>

          <div className="mt-6 h-px w-full bg-mauve-300/60" />

          <p className="mt-6 tracking-[0.25em] uppercase text-sm text-ink-500">
            Bald erhältlich
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="overflow-hidden rounded-[32px] shadow-sm bg-white">
            <img
              src="/products/new-arrival-divider-notebook.png"
              alt="Personalisierbares Divider-Notizbuch"
              className="w-full aspect-[5/4] object-cover transition-transform duration-500 ease-out hover:scale-105"
            />
          </div>

          <div>
            <p className="tracking-[0.25em] uppercase text-xs text-mauve-500 mb-4">
              Neues Produkt
            </p>

            <h3 className="font-serif text-4xl text-ink-900 leading-tight">
              Personalisierbares <br />
              Divider-Notizbuch
            </h3>

            <p className="mt-6 text-ink-700 leading-8 text-lg">
              Ein praktisches Spiralnotizbuch mit vier Divider-Tabs, ideal zum
              Organisieren von Notizen, Unterricht, Studieninhalten und
              persönlichen Reflexionen.
            </p>

            <p className="mt-6 inline-flex rounded-full bg-mauve-100 px-5 py-2 text-[11px] tracking-[0.25em] uppercase text-mauve-700">
              Bald erhältlich
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
